import React, { useState, useContext } from 'react';
import DropDown from './DropDown';
import { TranslationContext } from "./Context";

function MatchingOEMNumbersForArticle(props) {
    const translation = useContext(TranslationContext);
    const [oemNumbers, setOEMNumbers] = useState(null);

    function handleManufacturerChange(e) {
        const mfrId = Number.parseInt(e.value);

        if (mfrId > 0) {
            const filtered = props.items.filter(x => x.mfrId === mfrId);
            setOEMNumbers(filtered);
        }
        else {
            setOEMNumbers(null);
        }
    }

    const createOptions = () => {
        const result = [];
        props.items.map(x => {
            if (!result.some(r => r.mfrId === x.value)) {
                result.push({ value: x.mfrId, label: x.mfrName });
            }
        });

        return result;
    };

    return (

        <div className="vehicleProductListComponent-panelBody">
            <div><DropDown onChange={handleManufacturerChange} id='manufacturer' label={translation["TecAlliencePartSearch.ProductList.ItemList.OENumbersManufacturer"]}
                options={createOptions()} />
                {oemNumbers && oemNumbers.map(oem => {
                    return <div key={oem.mfrId + '_' + oem.articleNumber} className="vehicleProductListComponent-boxRow">
                        <div className="vehicleProductListComponent-boxTitle">{oem.articleNumber}</div>
                        <div className="vehicleProductListComponent-boxDesc"></div>
                    </div>
                })}
            </div>

        </div>

    );

}
export default MatchingOEMNumbersForArticle;